import HorizontalGraph from './../modules/horizontal_graph/main';
import Donut from './../modules/donut/main';
import ROMap from './../modules/ro_map/main';
import Tooltip from './../modules/tooltip/main';
import MultiColumn from './../modules/multicolumn/main';
import SimpleEvent from './../zviz2/zviz/event';
import state from './../zviz2/zviz/state';
import IndicatorMenu from './../modules/indicator_menu/main';
import Video from './../modules/video/main';
import Projects from './../modules/video/projects';
import Subnav from './../modules/subnav/main';
import Nav from './../modules/navigation/main';
import BarChart from './../modules/barchart/main';
import Bubbles from './../modules/bubbles/main';
import SDG from './../modules/sdg/main';
import ThemeGraph from './../modules/themegraph/main';

window.zolabo = window.zolabo || {};

window.zolabo.trackEvent = function(cat, action, label=''){
    if(window.ga && window.ga instanceof Function){
        window.ga('send', {
            hitType: 'event',
            eventCategory: cat,
            eventAction: action,
            eventLabel: label
        });
    }
}

window.zolabo.horizontalGraph = HorizontalGraph;
window.zolabo.barChart = BarChart;
window.zolabo.donut = Donut;
window.zolabo.map = ROMap;
window.zolabo.tooltip = Tooltip;
window.zolabo.multiColumn = MultiColumn;
window.zolabo.indicatorMenu = IndicatorMenu;
window.zolabo.visualizations = {};
window.zolabo.video = Video;
window.zolabo.projects = Projects;
window.zolabo.subnav = Subnav;
window.zolabo.navigation = Nav;
window.zolabo.bubbles = Bubbles;
window.zolabo.sdg = SDG;
window.zolabo.themeGraph = ThemeGraph;

window.zolabo.toggleDevelopments = function(){
    let headers = document.getElementsByClassName('devItemHeader');
    let headerClick = function(event){
        let c = this.parentNode.className || '';
        if(c.indexOf(' expand')==-1){
            this.parentNode.setAttribute('class', c + ' expand');
            if(this.parentNode.id){
                let obj = zolabo.visualizations[this.parentNode.id] || false;
                if(event){
                    let t = this.parentNode.getElementsByClassName('devTitle');
                    let title = this.parentNode.id;
                    if(t && t[0]){
                        title = t[0].textContent;                    
                    }
                    zolabo.trackEvent('country development', (window.countryId || 'country'), title);
                }
                if(obj){
                    if(obj instanceof Array){
                        for(let i = 0; i < obj.length; i++){
                            obj[i].reset();
                        }
                    }else{
                        obj.reset();
                    }
                }
            }
        }else{
            this.parentNode.setAttribute('class', c.replace(' expand', ''));
        }
    }
    if(headers){
        for(let i = 0; i < headers.length; i++){
            new SimpleEvent(headers[i], 'click', [headers[i], headerClick]);
            if(i == 0){
                headerClick.call(headers[i]);
            }
        }
    }
}